import * as Common from '@tfo/common'
import { CompanyUserRoles } from '@tfo/common/src/enums'
import { action, observable } from 'mobx'
import $http from '../utils/$http'
import RootStore from './RootStore'

type Role = { role: CompanyUserRoles }

type CustomerLoginResponse = {
	id: number
	firstName: string
	lastName: string
	email: string
	companyId: number
	roles: Role[]
	phoneNumber?: string
	language: string
    recipientIds?: number[]
	isActive: boolean
	token: string
	needToChangePasswordOnNextLogin?: boolean
	lastActivity?: Date
	acceptedGeneralTerms?: Date
}

export class LoginStore {
	@observable public email = ''
	@observable public password = ''
	@observable public rootStore: RootStore
	@observable public hasError = false
	@observable public loading = false
	@observable public showPasswordMenu = false
	@observable public hasNoActivatedBankId = false

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
	}

	@action public onChange(key: string, value: string) {
		this[key] = value
	}

	@action public onShowPasswordMenu() {
		this.showPasswordMenu = !this.showPasswordMenu
	}

	@action public onKeyDown(keyCode: number) {
		if (keyCode === 13) {
			this.onLogin()
		}
	}

	@action public onLogin() {
		this.loading = true
		const credentials = {
			userId: this.email,
			password: this.password,
			userType: 'Company',
		}

		return $http.post('/user/login', credentials)
			.then((data: any) => {
				data.lastActivity = new Date()

				// // FIXME!!! Initilization is brittle, make stores listen to each other
				Common.utils.setCookie(JSON.stringify(data))
				this.rootStore.login().catch(console.error)
			})
			.catch((e) => {
				console.log(e)
				this.hasError = true
			})
			.finally(() => {
				this.loading = false
			})
	}

	@action public onBankIdLogin(encryptedCompletionData: string) {
		this.loading = true

		return $http.post<CustomerLoginResponse>('/authenticate/bankid/login', {
			encryptedCompletionData: encryptedCompletionData,
			userType: Common.models.UserType.Company
		}).then((data: CustomerLoginResponse) => {
			if(data === null) {
								this.hasNoActivatedBankId = true
			} else {
				data.lastActivity = new Date()

				// // FIXME!!! Initilization is brittle, make stores listen to each other
				Common.utils.setCookie(JSON.stringify(data))
				this.rootStore.login().catch(console.error)
			}
		})
			.catch((e) => {
                const errorString = e.toString()
                if(errorString.includes("404")){
                    this.hasNoActivatedBankId = true
                }
                console.log(e)
            })
			.finally(() => {
				this.loading = false
			})
	}
}
